// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"2ace066e","977":"2e3cad87"}[chunkId] + ".chunk.js";
};